export enum AllFilterSelectors {
  'AllRegions' = 'Alle kommuner',
  'PartnerRegions' = 'Partnerkommuner',
  'AllCourses' = 'Alle forløb',
  'AllGenders' = 'Alle køn',
  'AllAgeRanges' = 'Alle aldre',
  'AllPeriods' = 'Altid',
}
